<template>
  <!-- eslint-disable vue/no-mutating-props -- address is a nested reactive object whose fields are bound via v-model from the parent form state -->
  <div class="group">
    <div class="field">
      <label :for="fieldId(errorPrefix, 'street')">{{ $t('street') }}</label>
      <div>
        <input :id="fieldId(errorPrefix, 'street')" type="text" required v-model="address.street" />
        <v-form-error :error="errors[`${errorPrefix}.street`]" />
      </div>
    </div>

    <div class="field">
      <label :for="fieldId(errorPrefix, 'number')">{{ $t('street number') }}</label>
      <div>
        <input
          :id="fieldId(errorPrefix, 'number')"
          type="text"
          required
          inputmode="numeric"
          pattern="[0-9]*"
          novalidate
          v-model="address.number"
        />
        <v-form-error :error="errors[`${errorPrefix}.number`]" />
      </div>
    </div>

    <div class="field">
      <label :for="fieldId(errorPrefix, 'numberaddition')">{{ $t('street number-addition') }}</label>
      <div>
        <input :id="fieldId(errorPrefix, 'numberaddition')" type="text" v-model="address.numberaddition" />
        <v-form-error :error="errors[`${errorPrefix}.numberaddition`]" />
      </div>
    </div>
  </div>

  <div class="group">
    <div class="field">
      <label :for="fieldId(errorPrefix, 'zipcode')">{{ $t('zipcode') }}</label>
      <div>
        <input :id="fieldId(errorPrefix, 'zipcode')" type="text" required v-model="address.zipcode" />
        <v-form-error :error="errors[`${errorPrefix}.zipcode`]" />
      </div>
    </div>

    <div class="field">
      <label :for="fieldId(errorPrefix, 'locality')">{{ $t('locality') }}</label>
      <div>
        <input :id="fieldId(errorPrefix, 'locality')" type="text" required v-model="address.locality" />
        <v-form-error :error="errors[`${errorPrefix}.locality`]" />
      </div>
    </div>
  </div>

  <div class="field">
    <label :for="fieldId(errorPrefix, 'country')">{{ $t('country') }}</label>
    <div>
      <select :id="fieldId(errorPrefix, 'country')" v-model="address.country">
        <option v-for="country in countries" :key="country.code" :value="country.code">
          {{ country.title }}
        </option>
      </select>
      <v-form-error :error="errors[`${errorPrefix}.country`]" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Address } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

type Country = {
  code: string
  title: string
  demonym: string
}

defineProps<{
  address: Address
  errors: Record<string, string>
  errorPrefix: string
  countries: Country[]
}>()
</script>
